<template>
  <hm-content>
    <el-row type="flex" justify="space-between" align="middle">
      <el-button class="table-panel" type="primary" @click="handleOnConfig" size="small">会员归属绑定</el-button>
      <div class="table-panel flex flex-end">
        <div>
          <el-select
            clearable
            class="mr10"
            size="small"
            v-model="searchCondition.timeType"
            placeholder="请选择二维码场景"
            filterable
          >
            <el-option label="天" :value="0"></el-option>
            <el-option label="小时" :value="1"></el-option>
          </el-select>
          <el-select
            class="mr10"
            size="small"
            v-model="searchCondition.subscribeSource"
            placeholder="请选择关注渠道"
            filterable
            clearable
          >
            <el-option label="公众号" value="wechat"></el-option>
            <el-option label="小程序" value="union"></el-option>
            <el-option label="扫码" value="qrcode"></el-option>
          </el-select>
          <el-date-picker
            v-model="searchCondition.date"
            type="daterange"
            align="right"
            start-placeholder="请选择关注时间段"
            end-placeholder="请选择关注时间段"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
          <el-input
            clearable
            style="width:250px"
            class="mr10"
            v-model="searchCondition.keyword"
            size="small"
            placeholder="请输入微信编号/微信昵称/手机号"
          ></el-input>
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出</el-button
          >
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </div>
      </div>
    </el-row>
    
    <div class="table">
      <el-table
        :data="fansMgtList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="微信编号"
          width="180"
          prop="wechatCode"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="nickName"
          label="微信昵称"
          width="180"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="authMobile"
          label="授权手机"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="subscribeTime"
          label="关注时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="subscribeSource"
          label="关注渠道"
        >
          <!-- <template slot-scope="scope">
            <span v-show="scope.row.subscribeSource === 'wechat'">公众号</span>
            <span v-show="scope.row.subscribeSource === 'union'">小程序</span>
            <span v-show="scope.row.subscribeSource === 'qrcode'">扫码</span>
          </template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="qrcodeScene"
          label="二维码场景"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wechatAvatar"
          label="微信头像"
        >
          <template slot-scope="scope">
            <img
              style="width:100%;"
              v-if="scope.row.wechatAvatar"
              :src="scope.row.wechatAvatar"
              alt="身份背景"
            />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relationSpu"
          label="关注状态"
        >
          <template slot-scope="scope">
            <span class="success" v-show="scope.row.subscribeState === 'yes'"
              >关注</span
            >
            <span class="danger" v-show="scope.row.subscribeState === 'no'"
              >未关注</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机"
        ></el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="fansMgtList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>

      <el-dialog
        title='会员归属绑定'
        :visible.sync='configVisible'
        width='600px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        @close="handleClose"
      >
        <el-form :model="configForm" size="small">
          <el-form-item label="绑定会员">
            <el-switch
              size="mini"
              v-model="configForm.optionValues"
              active-value="0"
              inactive-value="1"
              active-color="#2FC348"
              inactive-color="#D8D8D8"
            ></el-switch>
          </el-form-item>
          <el-form-item v-if="configForm.optionValues=='0'" prop="paramValue" label="有效期" :rules="[{required: true, message: '请输入时间', trigger: 'blur'}]">
            <el-input-number v-model="configForm.paramValue" :precision="0" :min="1" :controls="false"></el-input-number>
            分钟
          </el-form-item>
        </el-form>
        <template slot='footer'>
          <el-button @click='handleConfig' type='primary' size='small'>确定</el-button>
        </template>
      </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  data() {
    return {
      isOutputing: false,
      currentRow: {},
      searchCondition: {},
      checkedRow: [],
      currentPage: 1,
      pageSize: 10,
      configVisible: false,
      configForm: {
        optionValues: '1',
        paramValue: undefined,
      },
      detailInfo: null
    };
  },
  computed: mapGetters(["fansMgtList", "allFansMgtList"]),
  watch: {
    "fansMgtList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          // this.queryList();
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  methods: {
    /**
     * @desc 会员归属绑定
    */
    handleOnConfig() {
      this.$store
      .dispatch("getModelByParamCode", {
        paramCode: "member_query_is_time_button",
      })
      .then((res) => {
        console.log("---res---", res);
        this.detailInfo = res.result;
        if (!res.result) {
          this.configForm =  {
            optionValues: '1',
            paramValue: undefined,
          }
        } else {
          this.configForm.optionValues = res.result.optionValues
          this.configForm.paramValue = res.result.paramValue
        }
        this.configVisible = true;
      });
    },
    handleConfig() {
      if (!this.detailInfo) {
        // 新增
        this.$store
          .dispatch("addStoreSystemParamInfo", {
            paramCode: "member_query_is_time_button",
            optionValues: this.configForm.optionValues,
            paramValue: this.configForm.paramValue,
            configType: "store",
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message.success("配置成功！");
              this.configVisible = false;
            }
          });
      } else {
        this.$store
          .dispatch("editStoreSystemParamInfo", {
            paramCode: "member_query_is_time_button",
            optionValues: this.configForm.optionValues,
            paramValue: this.configForm.paramValue,
            id: this.detailInfo.id,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message.success("配置成功！");
              this.configVisible = false;
            }
          });
      }
    },
    handleClose() {
      this.configForm =  {
        optionValues: '1',
        paramValue: undefined,
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    searchGuider() {},
    save() {},
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then((res) => {
            const list = this.fansMgtList.records;
            list.forEach((v) => {
              // if (v.subscribeSource === "wechat") {
              //   v.subscribeSource = "公众号";
              // } else if (v.subscribeSource === "union") {
              //   v.subscribeSource = "小程序";
              // } else if (v.subscribeSource === "qrcode") {
              //   v.subscribeSource = "扫码";
              // }
              if (v.subscribeState === "yes") {
                v.subscribeState = "关注";
              } else if (v.subscribeState === "no") {
                v.subscribeState = "未关注";
              }
            });

            const tHeader = [
              "微信编号",
              "微信昵称",
              "授权手机",
              "关注时间",
              "关注渠道",
              "二维码场景",
              "微信头像",
              "关注状态",
              "会员手机",
            ];
            const filterVal = [
              "wechatCode",
              "nickName",
              "authMobile",
              "subscribeTime",
              "subscribeSource",
              "qrcodeScene",
              "wechatAvatar",
              "subscribeState",
              "memberMobile",
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "粉丝管理" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    reset() {
      this.searchCondition = {};
    },
    queryAllList() {
      return this.$store.dispatch("queryAllFansMgtList", {
        pageNo: 1,
        pageSize: 99999,
      });
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      this.setParamsCookie();
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.subscribeTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.subscribeTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryFansMgtList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "fansMgtParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "fansMgtParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-input-number {
  .el-input {
    width: 100%;
  }
  .el-input__inner {
    text-align: left;
  }
}
</style>
